import { useAuthenticator } from "@aws-amplify/ui-react";
import { Nav, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { signOut } from "aws-amplify/auth";
import { useProfileContext } from "../contexts/ProfileContexts";
import { useEffect } from "react";
import { refreshMe } from "../utils";

const TopNav = () => {
  const useAuthenticatorReturn = useAuthenticator();

  const cognitoUser = useAuthenticatorReturn.user;
  const { setProfile, setUser, user } = useProfileContext();
  useEffect(() => {
    console.log("cognito user", cognitoUser);
    if (cognitoUser && !user) {
      refreshMe(setUser, setProfile);
    }
  }, [cognitoUser, setProfile, setUser]);

  const mySignOut = () => {
    console.log("signing out");
    signOut();
  };
  return (
    <Navbar bg="light" expand="lg" className="px-4">
      <LinkContainer to="/">
        <Navbar.Brand>StubMiner</Navbar.Brand>
      </LinkContainer>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <LinkContainer to="/settings">
            <Nav.Link>Settings</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/faq">
            <Nav.Link>FAQ</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/stubtracker">
            <Nav.Link>Stubtracker</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/purchase">
            <Nav.Link>Purchase</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/downloads">
            <Nav.Link>Download</Nav.Link>
          </LinkContainer>
          {user?.isAdmin && (
            <LinkContainer to="/device-orders">
              <Nav.Link>Device Orders</Nav.Link>
            </LinkContainer>
          )}
        </Nav>
      </Navbar.Collapse>
      <Navbar.Collapse className="justify-content-end">
        {user && (
          <LinkContainer to="/account">
            <Nav.Link>{cognitoUser.signInDetails?.loginId}</Nav.Link>
          </LinkContainer>
        )}
        <Nav.Link onClick={mySignOut} className="mx-4">
          Sign Out
        </Nav.Link>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default TopNav;
